import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { connect } from "react-redux";
import { getALLTeacher, getALLStudent } from "../../../configs/redux/action";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import formatDate from "components/calendar/FormatDate";

const schema = yup
  .object({
    student_id: yup.number().positive().integer().required(),
    year: yup.number().positive().integer().required(),
    month: yup.number().positive().integer().required(),
    week_number: yup.number().positive().integer().required(),
    activity: yup.string().required(),
  })
  .required();

const ClassModal = ({
  isOpen,
  handleCloseModal,
  selectedRow,
  handleSaveChanges,
  getALLStudent,
  dataStudent,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    getALLStudent();
  }, [getALLStudent]);

  useEffect(() => {
    if (selectedRow) {
      setValue("student_id", selectedRow.student_id);
      setValue("activity", selectedRow.activity);
      setValue("year", selectedRow.year);
      setValue("month", selectedRow.month);
      setValue("week_number", selectedRow.week_number);
    } else {
      setValue("student_id", "");
      setValue("activity", "");
      setValue("year", "");
      setValue("month", "");
      setValue("week_number", "");
    }
  }, [selectedRow, setValue]);

  const onSubmit = (data) => {
    let id = selectedRow?.id || 0;
    handleSaveChanges(id, data);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCloseModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Data</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <FormControl mb={4}>
              <FormLabel htmlFor="teacher_id"> Year </FormLabel>
              <Input
                type="number"
                id="year"
                {...register("year")}
                placeholder="Year"
              />
              {errors.year && (
                <Text fontSize="xs" color="tomato">
                  {errors.year.message}
                </Text>
              )}
            </FormControl>
            <FormControl mb={4}>
              <FormLabel htmlFor="month"> Month</FormLabel>
              <Select name="month" id="month" {...register("month")}>
                <option value="">Select Month</option>
                <option value="1">Januari</option>
                <option value="2">Februari</option>
                <option value="3">Maret</option>
                <option value="4">April</option>
                <option value="5">Mei</option>
                <option value="6">Juni</option>
                <option value="7">Juli</option>
                <option value="8">Agustus</option>
                <option value="9">September</option>
                <option value="10">Oktober</option>
                <option value="11">November</option>
                <option value="12">Desember</option>
              </Select>

              {errors.month && (
                <Text fontSize="xs" color="tomato">
                  {errors.month.message}
                </Text>
              )}
            </FormControl>
            <FormControl mb={4}>
              <FormLabel htmlFor="week_number"> week_number</FormLabel>
              <Select
                name="week_number"
                id="week_number"
                {...register("week_number")}
              >
                <option value="">Select week_number</option>
                <option value="1">Minggu Ke 1</option>
                <option value="2">Minggu Ke 2</option>
                <option value="3">Minggu Ke 3</option>
                <option value="4">Minggu Ke 4</option>
              </Select>

              {errors.week_number && (
                <Text fontSize="xs" color="tomato">
                  {errors.week_number.message}
                </Text>
              )}
            </FormControl>

            <FormControl mb={4}>
              <FormLabel htmlFor="student_id">Student Name</FormLabel>
              <Select
                name="student_id"
                id="student_id"
                {...register("student_id")}
              >
                <option value="">Select Student</option>
                {dataStudent.map((student) => (
                  <option key={student.id} value={student.id}>
                    {student.nis} || {student.name}
                  </option>
                ))}
              </Select>
              {errors.teacher_id && (
                <Text fontSize="xs" color="tomato">
                  {errors.teacher_id.message}
                </Text>
              )}
            </FormControl>

            <FormControl mb={4}>
              <FormLabel htmlFor="activity">Catatan</FormLabel>
              <Textarea id="activity" {...register("activity")} />
              {errors.activity && (
                <Text fontSize="xs" color="tomato">
                  {errors.activity.message}
                </Text>
              )}
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} type="submit">
              Save Changes
            </Button>
            <Button variant="ghost" onClick={handleCloseModal}>
              Cancel
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

const reduxState = (state) => ({
  dataStudent: state.getData.dataStudent.data,
  LoadingData2: state.getData.dataStudent.loading,
});

const reduxDispatch = (dispatch) => {
  return {
    getALLStudent: () => dispatch(getALLStudent()),
  };
};

export default connect(reduxState, reduxDispatch)(ClassModal);
